import { useTransitionNavigate } from './PageTransition';
import { Hoverable } from './Hoverable';
import { useMagnetic } from '../hooks/useMagnetic';
import { color, font, maxWidth } from '../styles/tokens';

// Sticky bottom CTA. Rendered only when `enabled` (the prototype's stickyQuote prop).
export const QuoteBar = ({ enabled = true }) => {
  const navigate = useTransitionNavigate();
  const mag = useMagnetic();
  if (!enabled) return null;

  return (
    <div
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 55,
        background: 'rgba(77,141,255,.14)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        borderTop: '1px solid rgba(77,141,255,.3)',
        boxShadow: '0 -8px 30px -12px rgba(0,0,0,.6)',
      }}
    >
      <div
        style={{
          maxWidth,
          margin: '0 auto',
          padding: '15px 28px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 14,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span style={{ font: `500 15px ${font.display}`, color: color.text }}>
          Need a quote on precision honing tools?
        </span>
        <Hoverable
          as="button"
          onClick={() => navigate('/contact')}
          {...mag}
          style={{
            background: color.accent,
            color: color.bg,
            border: 'none',
            borderRadius: 999,
            padding: '10px 22px',
            font: `600 14px ${font.display}`,
            cursor: 'pointer',
            transition: 'transform .3s cubic-bezier(.16,1,.3,1),background .2s',
          }}
          hoverStyle={{ background: color.accentSoft }}
        >
          Request a Quote →
        </Hoverable>
      </div>
    </div>
  );
};
